import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as Monogram } from 'assets/brand/monogram.svg';
import { ReactComponent as Wordmark } from 'assets/brand/wordmark.svg';

/*
 * Mobeat gold, and the 2022 drawing, unchanged.
 *
 * These files are a trace of the original logo, both of its tones included, so what renders
 * is what has always rendered — the redraw is gone. The colours are baked into the paths
 * rather than taken from `currentColor`, because the mark is a fixed asset: changing the
 * product accent does not change the logo, and a logo with two tones cannot be driven by a
 * single colour anyway. RevenueCat is red in every theme for the same reason.
 *
 * That also means `sx={{ color }}` will not recolour it. A one-colour version, for print or
 * a partner deck, is a separate asset rather than a prop.
 *
 * The cost of tracing a 662px bitmap faithfully is node count — 83KB against the 3KB a
 * typeset redraw took. If that ever matters the fix is redrawing this shape by hand, not
 * replacing it with a different one.
 */

Logo.propTypes = {
  sx: PropTypes.object,
};

LogoIcon.propTypes = {
  sx: PropTypes.object,
};

/**
 * The M on its own, in a square. This is the mark to use anywhere vertical room is
 * tight — a navbar, an avatar, a favicon — because it fills its box rather than
 * spending most of it on the wordmark's descender.
 */
export function LogoIcon({ sx }) {
  return (
    <Box
      component={Monogram}
      sx={{
        width: 40,
        height: 40,
        display: 'block',
        ...sx,
      }}
    />
  );
}

/**
 * The full lockup.
 *
 * Sized by height with the width left to follow, so it can never be squashed. Note that
 * the pulse's descender makes this box much taller than the letters inside it: the
 * letterforms are 23% of the box height, so this 64px box renders them at about
 * 15px and matches the footprint the old PNG had. Much below this the wordmark stops being
 * readable and `LogoIcon` is the better mark.
 */
export default function Logo({ sx }) {
  return (
    <Box
      component={Wordmark}
      sx={{
        height: 64,
        width: 'auto',
        display: 'block',
        ...sx,
      }}
    />
  );
}
